<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4C20B/4C20B.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4C20B 2.0T Gasoline Engine</div>
        <div class="detail-banner-desc">
          
          Core Technologies: Electronically controlled waste‑gate twin‑scroll turbocharger, 350‑bar fuel‑injection system, cylinder‑head‑integrated exhaust manifold, dual variable valve timing (intake and exhaust), and thermal‑management module.
        </div>
      </div>
    </div>
    <div class="detail-box ">
      <div class="detail-title">Core Parameters</div>
      <div class="detail-utils">
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum power (N·m)</div>
          <div class="detail-utils-u">165/5500rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Maximum torque (kW)</div>
          <div class="detail-utils-u">385/1800-3600rpm</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Displacement (L)</div>
          <div class="detail-utils-u">1.967</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Minimum BSFC (g/kW·h)</div>
          <div class="detail-utils-u">229</div>
        </div>
        <div class="detail-utils-item">
          <div class="detail-utils-d">Emission standard</div>
          <div class="detail-utils-u">China 6b</div>
        </div>

      </div>
      <div class="detail-four-list">
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-1.jpg" alt=""></div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Thermal Management Module</div>
          <div class="detail-four-desc">
            The electronically controlled thermal‑management module ensures rapid coolant warm‑up, reducing warm‑up time by 5 minutes. It intelligently regulates and controls engine temperature to ensure efficient and stable operation under all conditions.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="detail-four-title">Cylinder‑Head‑Integrated Exhaust Manifold</div>
          <div class="detail-four-desc">
            Integrated exhaust manifold effectively reduces overall engine weight.<br />
            During warm-up, utilizes exhaust energy to rapidly heat coolant, shortening warm-up time and improving fuel economy and emissions.<br />
            Under high-load conditions, the integrated cooling jacket lowers exhaust temperature, reduces fuel enrichment requirements, and enhances both fuel efficiency and emissions performance.
          </div>
        </div>
        <div class="detail-four-item">
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-2.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-box detail-bottom-bgs">
      <div class="detail-updown-list">
        <div class="detail-updown-item">
          <div class="detail-updown-title">Electronically Controlled Waste‑Gate Twin‑Scroll Turbocharger</div>
          <div class="detail-updown-desc">
            The twin‑scroll turbine housing reduces exhaust‑pulse interference and improves response.<br />
            A 6‑large‑6‑small fully‑machined compressor wheel eliminates Blade Passing Frequency (BPF) whistle.<br />
            The electronically controlled waste‑gate offers high precision and improved dynamic response.<br />
            Compared to the previous generation, rotating inertia is reduced by 27%, compressor efficiency is increased by 3%, turbine efficiency is increased by 5%, and power responsiveness is improved by 60%.
          </div>
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-3.jpg" alt=""></div>
        </div>
        <div class="detail-updown-item">
          <div class="detail-updown-title">Fuel Injection System</div>
          <div class="detail-updown-desc">
            The 350‑bar fuel injection system improves fuel atomization, ensuring more homogeneous air‑fuel mixing and effectively reducing engine emissions.<br />
            The nozzle uses laser‑drilled holes to enhance atomization, reduce penetration distance, and lower emissions.<br />
            An independent multi‑orifice spray design offers greater flexibility, with differently sized holes improving mixture homogeneity. The injector supports up to 3 injections per cycle for more flexible fuel‑control strategies.
          </div>
          <div class="img-box"><img src="/assets/product/engine/4C20B/4C20B-4.jpg" alt=""></div>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4C20B/4C20B-5.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            Timing System
          </div>
          <div class="detail-desc">
            Supports dual Camshaft Correlation Technology (CCT) for both intake and exhaust, optimizing combustion, reducing fuel consumption, increasing torque, and lowering emissions.
          </div>
        </div>

      </div>
    </div>


  </div>
  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4C20B 2.0T Gasoline Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4C20B.html'

};

import { createApp } from 'vue';
import App from './4C20B.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4C20B.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>